import { render } from "./automatizar-editar.vue?vue&type=template&id=132d7467"
import script from "./automatizar-editar.vue?vue&type=script&lang=js"
export * from "./automatizar-editar.vue?vue&type=script&lang=js"

import "./automatizar-editar.vue?vue&type=style&index=0&id=132d7467&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__